import { useEffect, useState } from "react";

const canFullscreen = () => typeof document !== "undefined" && !!document.fullscreenEnabled;

export function useFullscreen() {
  const [active, setActive] = useState(!!document.fullscreenElement);
  useEffect(() => {
    const on = () => setActive(!!document.fullscreenElement);
    document.addEventListener("fullscreenchange", on);
    return () => document.removeEventListener("fullscreenchange", on);
  }, []);
  const toggle = async () => {
    try {
      if (document.fullscreenElement) await document.exitFullscreen();
      else await document.documentElement.requestFullscreen();
    } catch (e) {
      console.warn("fullscreen not available", e);
    }
  };
  return { supported: canFullscreen(), active, toggle };
}
